import { AdminPage, AdminPageHeader } from '../../components/layout/AdminPage';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { MemberDto } from '@pokerroom/types';
import { api } from '../../lib/api';
import { memberCardTokenFromQr } from './memberCardQr';

export default function MemberCardScanPage() {
  const { t } = useTranslation('member');
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = memberCardTokenFromQr(window.location.href, window.location.origin);
    window.history.replaceState(window.history.state, '', '/members/scan');
    if (!token) {
      setError(true);
      return;
    }
    let cancelled = false;
    void api
      .post<MemberDto>('/members/portal-card/resolve', { token })
      .then((member) => {
        if (!cancelled) navigate(`/members/${member.id}`, { replace: true });
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <AdminPage header={<AdminPageHeader title={t('cardScanTitle')} />}>
      <section role="status">{t(error ? 'cardScanFailed' : 'cardScanLoading')}</section>
    </AdminPage>
  );
}
